export default __webpack_public_path__ + "static/media/forms_icon.20949529.svg";